<template>
  <td :colspan="qtdeTd">
    <p class="ma-0 ml-1 py-3 subtitle-2">Filial {{linha.filial}} e suas Famílias de Distribuição</p>

    <div v-for="(fam, index) in linhaFormatada" :key="index" class="mx-1">
      <v-chip small class="subtitle-2 font-weight-medium mb-2">
        {{ `${fam.idcategoria} - ${fam.descricao}` }}
      </v-chip>

      <v-row no-gutters class="pb-5 d-flex">
        <v-flex xs2 class="mbs-5" v-for="(cat, subIndex) in fam.categorias" :key="`${index}-${subIndex}`">
          <v-list class="lista">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  <span>{{ `${cat.idcategoria} - ${cat.descricao}` }}</span>
                </v-list-item-title>

                <v-list-item-subtitle
                  v-for="(sub, key) in cat.subcategorias"
                  :key="`${index}-${subIndex}-${key}`"
                  style="font-size: 12px"
                >
                  {{ `${sub.idcategoria} - ${sub.descricao}` }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-row>

      <v-divider class="mb-4"/>
    </div>
  </td>
</template>

<script>
export default {
  name: "LinhaDataTableExpandida",
  props: {
    qtdeTd: {
      type: [Number, String],
      default: 1
    },
    linha: {
      type: Object,
      required: true
    }
  },
  computed: {
    linhaFormatada() {
      const {familiais_gerais: familiais, categorias: todasCategorias} = this.linha

      const categoriasGerais = todasCategorias.filter(({sub_categoria}) => !sub_categoria)
      const subCategorias = todasCategorias.filter(({sub_categoria}) => sub_categoria)

      const ADD_GRUPOS_E_SUBCATEGORIAS= fam => {
        let categorias = this.getItensFiltrados(categoriasGerais, fam.idcategoria)

        categorias = categorias.map(cat => {
          const subcategorias = this.getItensFiltrados(subCategorias, cat.idcategoria)

          return {...cat, subcategorias}
        })

        return {...fam, categorias}
      }

      return familiais.map(ADD_GRUPOS_E_SUBCATEGORIAS)
    }
  },
  methods: {
    getItensFiltrados(itens, idcategoria){
      const FILTRO = item => `${item.idcategoria}`.startsWith(`${idcategoria}`)
      return itens.filter(FILTRO)
    }
  }
}
</script>

<style scoped>
.lista {
  height: 250px;
  overflow-y: auto;
  border: 1px solid rgba(0,0,0,.2);
}
</style>
